$(document).ready(function () {
    $("#FAQ-content-faq-1 a[href='https://www.blackartdepot.com/pages/are-you-black-owned']").attr('aria-label', 'Read more about are you black owned');
    $("#FAQ-content-faq-1 a[href='https://www.blackartdepot.com/pages/are-you-black-owned']").removeAttr('title');
    $("#FAQ-content-faq-2 a[href='https://www.blackartdepot.com/pages/where-is-the-black-art-depot-located']").attr('aria-label', 'Read more where is black art depot located');
    $("#FAQ-content-faq-2 a[href='https://www.blackartdepot.com/pages/where-is-the-black-art-depot-located']").removeAttr('title');
    // $(".newsletter-template--16498134548645__form a[href='tel:(800) 525-7249']").attr('aria-label','Phone number, (800) 525-7249');
    // $(".newsletter-template--16498134548645__form a[href='tel:(678) 916-6545']").attr('aria-label','Number, (800) 525-7249');
    // $(".newsletter-template--16498134548645__form a[href='tel:1-800-525-7249']").attr('aria-label','Phone number, 1-800-525-7249');
    // $(".newsletter-template--16498134548645__form a[href='tel:678-916-6545']").attr('aria-label','Phone number, 678-916-6545');
    $("a[href='https://policies.google.com/privacy']").attr('aria-label','Privacy policy, you will be leaving this website and going to policies.google.com');
    $("a[href='https://policies.google.com/terms']").attr('aria-label','Terms of service, you will be leaving this website and going to policies.google.com');
    $('hr').attr('aria-hidden', 'true');
    $('br').attr('aria-hidden', 'true');
    $("ul.footer__menu a[href='/pages/accessibility-statement-commitment']").attr('id','Accessibility-statement');
    $('div.noUi-base .noUi-origin .noUi-handle-lower').attr('aria-label','From');
    $('div.noUi-base .noUi-origin .noUi-handle-upper').attr('aria-label','To');
    $('span.price-range__display-min').prepend('<span class="visually-hidden visually-hidden--inline">From</span>');
    $('span.price-range__display-max').prepend('<span class="visually-hidden visually-hidden--inline">To</span>');
    $('.hero--template--16498134450341__slideshow div.hero__text-shadow h2.h1').attr('aria-level','1');
    $('.hero--template--16498134548645__16566926918961e48a div.hero__text-shadow h2.h1').attr('aria-level','1');
    $('.hero--template--16498134581413__16570316726d58a9a4 div.hero__text-shadow h2.h1').attr('aria-level','1');
    $('.hero--template--16498134384805__16587789216006f284 a.btn').attr('aria-label','Learn more about us');
    $('.hero--template--16498134679717__1657032435edf85f66 div.hero__text-shadow h2.h1').attr('aria-level','1');
    $('.splide__slide[data-id="1657031672387d374e-0"]').removeAttr('role','tabpanel');
    $('.splide__slide[data-id="slideshow-0"]').removeAttr('role','tabpanel');
    $('.splide__slide[data-id="16566926910f00fa6a-0"]').removeAttr('role','tabpanel');
    $('.splide__slide[data-id="16566926910f00fa6a-0"]').removeAttr('role','tabpanel');
    $('.splide__slide[data-id="16570324358c6be864-0"]').removeAttr('role','tabpanel');
    $('div#AnnouncementSlider').removeAttr('tabindex');
    
    $('button.site-nav__link').click(function (e) {
      e.preventDefault();
      $(this).attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true'
      });
    });
    $('button.slide-nav__button').click(function (e) {
      e.preventDefault();
      $(this).attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true'
      });
    });
    
    $('.grid-view-btn').each(function() {
        const isButtonActive = $(this).hasClass('is-active');
        $(this).attr('aria-expanded', isButtonActive ? 'true' : 'false');
      });
    
      $('.grid-view-btn').click(function() {
        $('.grid-view-btn').removeClass('is-active').attr('aria-expanded', 'false');
        $(this).addClass('is-active').attr('aria-expanded', 'true');
      });
      
      $(".chaimg .hero__sidebyside-image").each(function (i) {
        $(this).detach().prependTo($(".chaimg").eq(i))
      });

      $('.grid-product__price--original span.visually-hidden').text('Sale price');
      $('.product__price.on-sale span.visually-hidden').text('Sale price');

      $('#shopify-section-template--16498134384805__slideshow .splide--fade').attr('aria-label','Homepage banner');

      $(".stamped-reviews-title .stamped-reviews-link").remove();

      $("button.trbtn").click(function(){
        $(this).toggleClass('active');
        $('.transtxt').toggleClass('usm');
        $(this).attr('aria-expanded', function(i, attr) {
          return attr == 'true' ? 'false' : 'true'
        });
      });


      $(".btn.contctform").attr("aria-label", "Send, when you click on this button after submiting the form, the page will be refreshed and focus goes to the top of the page");
      $(".newsbtn").attr("aria-label", "Subscribe, when you click on this button after enter the email, the page will be refreshed and focus goes to the top of the page");

    });

    $(document).ready(function () {
      setTimeout(function () {
       
        $(".spurit-po-wrapper .pre-order-custom").attr("role", "link");
 
 
      }, 3000);
      }, 3000);

      
      
          document.addEventListener('DOMContentLoaded', function () {
            var backToTopButton = document.getElementById('go-top');
          
            if (backToTopButton) {
              // Show the button when scrolling down
              window.addEventListener('scroll', function () {
                if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                  backToTopButton.style.display = 'block';
                } else {
                  backToTopButton.style.display = 'none';
                }
              });
          
              // Smooth scroll to the top when button is clicked
              backToTopButton.addEventListener('click', function (event) {
                event.preventDefault();
          
                // Scroll smoothly to the top
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
              });
            }
          });


          $("#crtnote").click(function(){
            $(this).attr('aria-expanded', function(i, attr) {
              return attr == 'true' ? 'false' : 'true'
            });
          });


          $(document).ready(function () {
            setTimeout(function () {
             
              $('input#notify_email').attr('aria-label','johnedoe@gmail.com');          
       
            }, 3000);
            }, 3000);
    
            $(document).ready(function () {
              setTimeout(function () {
               
                $('input.stamped-form-input').attr('aria-label','e.g Paris, France');
         
              }, 3000);
              }, 3000);

                 
            $('div.stamped-reviews-title a.stamped-reviews-link').html('Click here for reviews');
           
            